import React from "react";
import {
  Button,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Row,
  Col,
} from "reactstrap";
import Select from "react-select";
import { useTranslation } from "react-i18next";

const t_prefix = "pages.aboutUs.workWithUs";

export default function WorkWithUs() {
  const [specialitySelect, setSpecialitySelect] = React.useState(null);
  const [firstFocus, setFirstFocus] = React.useState(false);
  const [emailFocus, setEmailFocus] = React.useState(false);
  const { t } = useTranslation();

  return (
    <div className="about-contact">
      <Container>
        <Row>
          <Col className="mr-auto ml-auto" md="8">
            <h2 className="text-center title">{t(`${t_prefix}.title`)}</h2>
            <h4 className="text-center description">
            {t(`${t_prefix}.description`)}
            </h4>
            <Form className="contact-form">
              <Row xs="1" sm="1" md="2" style={{direction: 'ltr'}}>
                <Col>
                  <label>{t(`${t_prefix}.inputs.fullName`)}</label>
                  <InputGroup className={firstFocus ? "input-group-focus" : ""}>
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="now-ui-icons users_circle-08"></i>
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      autoComplete="firstname"
                      placeholder={t(`${t_prefix}.inputs.fullName`)}
                      type="text"
                      onFocus={() => setFirstFocus(true)}
                      onBlur={() => setFirstFocus(false)}
                    ></Input>
                  </InputGroup>
                </Col>
                <Col>
                  <label>{t(`${t_prefix}.inputs.email`)}</label>
                  <InputGroup className={emailFocus ? "input-group-focus" : ""}>
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="now-ui-icons ui-1_email-85"></i>
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      autoComplete="email"
                      placeholder={t(`${t_prefix}.inputs.email`)}
                      type="text"
                      onFocus={() => setEmailFocus(true)}
                      onBlur={() => setEmailFocus(false)}
                    ></Input>
                  </InputGroup>
                </Col>
                <Col>
                  <label>{t(`${t_prefix}.inputs.phone`)}</label>
                  <InputGroup className={emailFocus ? "input-group-focus" : ""}>
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="now-ui-icons ui-1_email-85"></i>
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      autoComplete="email"
                      placeholder={t(`${t_prefix}.inputs.phone`)}
                      type="text"
                      onFocus={() => setEmailFocus(true)}
                      onBlur={() => setEmailFocus(false)}
                    ></Input>
                  </InputGroup>
                </Col>
                <Col>
                  <FormGroup>
                    <label className="control-label">{t(`${t_prefix}.inputs.specialty`)}</label>
                    <Select
                      className="react-select react-select-primary"
                      onChange={(value: any) => setSpecialitySelect(value)}
                      classNamePrefix="react-select"
                      placeholder={t(`${t_prefix}.inputs.specialty`)}
                      value={specialitySelect}
                      name=""
                      options={[
                        {
                          value: "1",
                          label: "I'm a Designer",
                        },
                        { value: "2", label: "I'm a Developer" },
                        { value: "3", label: "I'm a Hero" },
                      ]}
                    ></Select>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col className="ml-auto mr-auto text-center">
                  <Button className="btn-round mt-4" color="info" size="lg">
                    Let's talk
                  </Button>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
